import { useHistory, useLocation } from 'react-router-dom';
import { ActiveSidebar } from './types';

const SIDEBAR_PARAM_KEYS = ['sidebar', 'periodStart', 'periodEnd'] as const;

export function usePeriodEndSidebar() {
  const { search } = useLocation();
  const history = useHistory();

  const searchParams = new URLSearchParams(search);
  const sidebarType = searchParams.get('sidebar') as
    | ActiveSidebar['type']
    | null;
  const periodStart = searchParams.get('periodStart') ?? undefined;
  const periodEnd = searchParams.get('periodEnd') ?? undefined;

  const activeSidebar: ActiveSidebar | null = (() => {
    if (!sidebarType) return null;
    switch (sidebarType) {
      case 'unrealisedFxGains':
      case 'accruals':
      case 'transactionRates':
      case 'prepayments':
        return periodStart && periodEnd
          ? { type: sidebarType, periodStart, periodEnd }
          : null;
      case 'companyValuations':
        return { type: 'companyValuations' };
      case 'bankBalances':
        return { type: 'bankBalances' };
      default:
        return null;
    }
  })();

  const openSidebar = (sidebar: ActiveSidebar) => {
    const next = new URLSearchParams(search);
    next.set('sidebar', sidebar.type);
    if ('periodStart' in sidebar) next.set('periodStart', sidebar.periodStart);
    if ('periodEnd' in sidebar) next.set('periodEnd', sidebar.periodEnd);
    history.replace({ search: next.toString() });
  };

  const closeSidebar = () => {
    const next = new URLSearchParams(search);
    SIDEBAR_PARAM_KEYS.forEach((key) => next.delete(key));
    history.replace({ search: next.toString() });
  };

  return { activeSidebar, openSidebar, closeSidebar };
}
